const t = {
  name: "Recurring",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22 9V2H20V6.00511C18.1779 3.57648 15.2716 2 12 2C6.47772 2 2 6.47772 2 12H4C4 7.58228 7.58228 4 12 4C14.5216 4 16.7752 5.17159 18.2412 7H15V9H22Z" fill="currentColor"/>
<path d="M9 15H2V22H4V17.9948C5.82209 20.4235 8.72844 22 12.0001 22C17.5224 22 22.0001 17.5223 22.0001 12H20.0001C20.0001 16.4177 16.4178 20 12.0001 20C9.47846 20 7.22488 18.8284 5.75888 17H9V15Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Recurring
};
